import {
  Button,
  ColumnLayout,
  Form,
  FormField,
  FormSection,
  Select,
  Flash,
  Badge,
  Toggle,
} from 'AWS-UI-Components-React';
import React from 'react';
import { getJSClient } from '../js_client';
import { addMonthYYYYMM, DATE_YYYYMM } from '../../utils/date-utils';
import '../../styles/config_central.css';

export class DevConfigContainer extends React.Component {
  constructor(props) {
    super(props);
    this.auroraOption = {
      label: 'Aurora',
      id: 'aurora',
    };
    this.athenaOption = {
      label: 'Athena',
      id: 'athena',
    };

    this.client = getJSClient();
    this.state = {
      modified: false,
      snapshotOptions: [],
      selectedSnapshot: {},
      snapshotEnabled: false,
      canPromoteSnapshot: false,
      snapshotUpdating: false,
      snapshotUpdated: false,
      snapshotUpdateFailed: false,
      snapshotUpdateErrorMessage: '',
      appConfig: this.props.appConfig,
    };
    this.datastoreOptions = [this.auroraOption, this.athenaOption];
    this.snapshotsMap = {};
  }

  componentDidMount = () => {
    this.getSnapshots();
    this.setConfigTable();
  };

  setConfigTable = () => {
    let appConfig = this.state.appConfig;
    if (appConfig.auroraEnabled) {
      this.setState({ GlobalDatastore: this.auroraOption });
    } else {
      this.setState({ GlobalDatastore: this.athenaOption });
    }

    if (appConfig.aurora13monthEnabled) {
      this.setState({ ThirteenMonthDatastore: this.auroraOption });
    } else {
      this.setState({ ThirteenMonthDatastore: this.athenaOption });
    }

    if (appConfig.auroraComponentEnabled) {
      this.setState({ ComponentReportDatastore: this.auroraOption });
    } else {
      this.setState({ ComponentReportDatastore: this.athenaOption });
    }

    if (appConfig.auroraMarketplaceEnabled) {
      this.setState({ MarketplaceReportDatastore: this.auroraOption });
    } else {
      this.setState({ MarketplaceReportDatastore: this.athenaOption });
    }

    if (appConfig.auroraPlEnabled) {
      this.setState({ PLReportDatastore: this.auroraOption });
    } else {
      this.setState({ PLReportDatastore: this.athenaOption });
    }

    this.setState({ originalConfig: appConfig, modified: false });
  };

  onDataStoreChange = (event) => {
    const storeType = event.currentTarget.component.controlId;
    const option = event.detail.selectedOption;
    switch (storeType) {
      case 'global':
        this.setState({ GlobalDatastore: option, modified: true });
        break;
      case '13-month':
        this.setState({ ThirteenMonthDatastore: option, modified: true });
        break;
      case 'component':
        this.setState({ ComponentReportDatastore: option, modified: true });
        break;
      case 'marketplace':
        this.setState({ MarketplaceReportDatastore: option, modified: true });
        break;
      case 'pl':
        this.setState({ PLReportDatastore: option, modified: true });
        break;
      default:
    }
  };

  saveAppConfig = (event) => {
    const config = this.state.originalConfig;
    config.auroraEnabled = this.getAuroraEnabled('GlobalDatastore', 'auroraEnabled');
    config.aurora13monthEnabled = this.getAuroraEnabled('ThirteenMonthDatastore', 'aurora13monthEnabled');
    config.auroraComponentEnabled = this.getAuroraEnabled('ComponentReportDatastore', 'auroraComponentEnabled');
    config.auroraExchangeRatesEnabled = this.getAuroraEnabled('ComponentReportDatastore', 'auroraComponentEnabled');
    config.auroraMarketplaceEnabled = this.getAuroraEnabled('MarketplaceReportDatastore', 'auroraMarketplaceEnabled');
    config.auroraPlEnabled = this.getAuroraEnabled('PLReportDatastore', 'auroraPlEnabled');
    this.client.saveAppConfig(this.onSaveConfigSuccess, this.onSaveConfigFailure, { config });
  };

  getAuroraEnabled(stateStore, originalStore) {
    if (!this.state[stateStore]) {
      return this.state.originalConfig[originalStore];
    }

    return this.state[stateStore] && this.state[stateStore].id === this.auroraOption.id;
  }

  onSaveConfigSuccess = (data) => {
    this.setConfigTable();
  };

  onSaveConfigFailure = (err) => {
    console.log(err);
  };

  getSnapshots = () => {
    this.client.pullSnapshots(
      this.onSnapshotsPull,
      (err) => {
        console.log(err);
      },
      {}
    );
  };

  /**
   * When an Admin selects a snapshot that
   * 1. has no staging changes
   * 2. has data starting from Jan 2019 to latest or previous to latest month,
   * Then Promote button should be enabled
   */
  isValidForPromote = (snapshot) => {
    return (
      snapshot.enabled &&
      !snapshot.plglStagingArea &&
      !snapshot.channelMappingStagingArea &&
      !snapshot.componentStagingArea &&
      snapshot.startMonth <= DATE_YYYYMM.START_MONTH &&
      (snapshot.endMonth === DATE_YYYYMM.PREV_MONTH || snapshot.endMonth === addMonthYYYYMM(DATE_YYYYMM.PREV_MONTH, -1)) &&
      snapshot.id !== this.state.appConfig.liveSnapshotId
    );
  };

  isLiveSnapshotSelected = () => {
    return this.state.selectedSnapshot.id === this.state.appConfig.liveSnapshotId;
  }

  onSnapshotsPull = (response) => {
    let dropdownItems = [];
    // sort in descending by timestamp
    let configList = response['configList'].sort((a, b) => parseFloat(b.timestamp) - parseFloat(a.timestamp));
    for (let config of configList) {
      this.snapshotsMap[config.id] = config;
      let item = {};
      item['label'] = config.name;
      item['id'] = config.id;
      if (config.id === this.state.appConfig.liveSnapshotId) {
        item['tags'] = ['Live'];
        // if snapshot is currently not selected in dropdwon then select the live one
        if (Object.keys(this.state.selectedSnapshot).length === 0) {
          this.setState({ selectedSnapshot: item });
          this.setState({ snapshotEnabled: config.enabled });
          this.setState({ canPromoteSnapshot: this.isValidForPromote(config) });
        }
      }
      dropdownItems.push(item);
    }
    this.setState({ snapshotOptions: dropdownItems });
  };

  onSnapshotChange = (event) => {
    const option = event.detail.selectedOption;
    let snapshot = this.snapshotsMap[option.id];
    this.setState({ selectedSnapshot: option });
    this.setState({ snapshotEnabled: snapshot.enabled });
    this.setState({ canPromoteSnapshot: this.isValidForPromote(snapshot) });
  };

  toggleSnapshotEnable = () => {
    this.setState({ snapshotUpdating: true });
    let config = this.snapshotsMap[this.state.selectedSnapshot.id];
    this.setState({ snapshotEnabled: !config.enabled });
    config['enabled'] = !config.enabled;
    this.client.saveSnapshot(
      this.onUpdateSnapshot,
      (err) => {
        console.log(err);
      },
      { config }
    );
  };

  promoteSnapshot = (change) => {
    this.setState({ snapshotUpdating: true });
    this.client.promoteSnapshot(
      this.onUpdateSnapshot,
      (err) => {
        console.log(err);
      },
      { id: this.state.selectedSnapshot.id },
      this.props.setAppConfig()
    );
  };

  deleteSnapshot = () => {
    this.setState({ snapshotUpdating: true });
    this.client.deleteSnapshot(
      this.onDeletedSnapshot,
      (err) => {
        console.log(`Failed to delete snapshot. Please try again. ERROR: ${err}`);
      },
      { id: this.state.selectedSnapshot.id }
    );
  };

  onDeletedSnapshot = (response) => {
    // remove deleted snapshot from view and reset selected snapshot to latest one
    this.setState({
      snapshotOptions: this.state.snapshotOptions.filter((option) => option.id !== this.state.selectedSnapshot.id),
      selectedSnapshot: this.state.snapshotOptions[0],
    });
    this.onUpdateSnapshot(response);
  };

  onUpdateSnapshot = (response) => {
    if (Object.keys(response.data).length === 0 || response.data.errorMessage === '') {
      this.setState({ snapshotUpdated: true, snapshotUpdating: false });
      this.getSnapshots(); // to refresh snapshotsMap
    } else {
      this.setState({
        snapshotUpdateFailed: true,
        snapshotUpdateErrorMessage: response.data.errorMessage,
        snapshotUpdating: false,
      });
    }
  };

  updateFlash = () => {
    if (this.state.snapshotUpdating) {
      return <Flash type="success" loading={true} dismissible={false} content="Updating snapshot..." />;
    } else if (this.state.snapshotUpdated) {
      return (
        <Flash type="success" dismissible={true} onDismiss={this.clearFlash}>
          Update Succeeded!
        </Flash>
      );
    } else if (this.state.snapshotUpdateFailed) {
      return (
        <Flash
          header={this.state.snapshotUpdateErrorMessage}
          type="error"
          dismissible={true}
          onDismiss={this.clearFlash}
        />
      );
    } else {
      return <div />;
    }
  };

  clearFlash = () => {
    this.setState({ snapshotUpdated: false, snapshotUpdateFailed: false });
  };

  render() {
    return (
      <div>
        <div className="awsui-util-container">
          <div className="awsui-util-container-header">
            <div className="awsui-util-action-stripe">
              <div className="awsui-util-action-stripe-title">
                Snapshot {this.state.selectedSnapshot.label}
                {this.isLiveSnapshotSelected() && (
                  <Badge color="blue"> Live </Badge>
                )}
              </div>
              <div className="awsui-util-action-stripe-group dev-config-controls">
                <Select
                  placeholder="Select a snapshot"
                  options={this.state.snapshotOptions}
                  selectedOption={this.state.selectedSnapshot}
                  onChange={this.onSnapshotChange}
                  filteringType="auto"
                />
                <Toggle
                  disabled={this.isLiveSnapshotSelected()}
                  onChange={this.toggleSnapshotEnable}
                  checked={this.state.snapshotEnabled}>
                  {this.state.snapshotEnabled ? 'Enabled' : 'Disabled'}
                </Toggle>
                <Button
                  text="Delete"
                  disabled={this.isLiveSnapshotSelected()}
                  onClick={this.deleteSnapshot}
                />
                <Button
                  text="Promote"
                  variant={'primary'}
                  onClick={this.promoteSnapshot}
                  disabled={ !this.state.canPromoteSnapshot }
                />
                <div>{this.updateFlash()}</div>
              </div>
            </div>
          </div>
          {this.state.selectedSnapshot.id && (
            <ColumnLayout columns={3} variant="text-grid">
              <div data-awsui-column-layout-root="true">
                <div>
                  <div className="awsui-util-label">User</div>
                  <div>{this.snapshotsMap[this.state.selectedSnapshot.id].user}</div>
                </div>
                <div>
                  <div className="awsui-util-label">Component Staging Area</div>
                  <div>{this.snapshotsMap[this.state.selectedSnapshot.id].componentStagingArea}</div>
                </div>
                <div>
                  <div className="awsui-util-label">PL GL Staging Area</div>
                  <div>{this.snapshotsMap[this.state.selectedSnapshot.id].plglStagingArea}</div>
                </div>
                <div>
                  <div className="awsui-util-label">Channel Mapping Staging Area</div>
                  <div>{this.snapshotsMap[this.state.selectedSnapshot.id].channelMappingStagingArea}</div>
                </div>

                <div>
                  <div className="awsui-util-label">Base Data table</div>
                  <div>{`base_data_${this.snapshotsMap[this.state.selectedSnapshot.id].baseDataTableSuffix}`}</div>
                </div>
                <div>
                  <div className="awsui-util-label">Exchange Rates table</div>
                  <div>{`exchange_rates_${
                    this.snapshotsMap[this.state.selectedSnapshot.id].exchangeRatesTableSuffix
                  }`}</div>
                </div>
                <div>
                  <div className="awsui-util-label">PL Rollups table</div>
                  <div>{`pl_rollups_${this.snapshotsMap[this.state.selectedSnapshot.id].plRollupsTableSuffix}`}</div>
                </div>

                <div>
                  <div className="awsui-util-label">Marketplace Pivot table</div>
                  <div>{`marketplace_pivot_${
                    this.snapshotsMap[this.state.selectedSnapshot.id].marketplaceRollupTableSuffix
                  }`}</div>
                </div>
                <div>
                  <div className="awsui-util-label">Raw Data table suffix</div>
                  <div>{this.snapshotsMap[this.state.selectedSnapshot.id].rawDataSuffix}</div>
                </div>
                <div>
                  <div className="awsui-util-label">Created Time</div>
                  <div>
                    {new Date(Number(this.snapshotsMap[this.state.selectedSnapshot.id].timestamp)).toLocaleDateString()}
                  </div>
                </div>
              </div>
            </ColumnLayout>
          )}
        </div>

        {this.state.modified && (
          <div className="awsui-util-action-stripe-large">
            <div className="awsui-util-action-stripe-title" />
            <div className="awsui-util-action-stripe-group">
              <Button text="Cancel" variant="link" onClick={this.setConfigTable} />
              <Button text="Submit" variant="primary" onClick={this.saveAppConfig} />
            </div>
          </div>
        )}
        <Form>
          <FormSection header="Datastore">
            <ColumnLayout columns={4} variant="text-grid">
              <div data-awsui-column-layout-root="true">
                <FormField label="Global Datastore">
                  <Select
                    controlId="global"
                    options={this.datastoreOptions}
                    selectedOption={this.state.GlobalDatastore}
                    selectedLabel="Selected"
                    onChange={this.onDataStoreChange}
                  />
                </FormField>
                <FormField label="13 Month Report">
                  <Select
                    controlId="13-month"
                    options={this.datastoreOptions}
                    selectedOption={this.state.ThirteenMonthDatastore}
                    selectedLabel="Selected"
                    onChange={this.onDataStoreChange}
                  />
                </FormField>
                <FormField label="Component Report">
                  <Select
                    controlId="component"
                    options={this.datastoreOptions}
                    selectedOption={this.state.ComponentReportDatastore}
                    selectedLabel="Selected"
                    onChange={this.onDataStoreChange}
                  />
                </FormField>
                <FormField label="Marketplace Report">
                  <Select
                    controlId="marketplace"
                    options={this.datastoreOptions}
                    selectedOption={this.state.MarketplaceReportDatastore}
                    selectedLabel="Selected"
                    onChange={this.onDataStoreChange}
                  />
                </FormField>
                <FormField label="PL Report">
                  <Select
                    controlId="pl"
                    options={this.datastoreOptions}
                    selectedOption={this.state.PLReportDatastore}
                    selectedLabel="Selected"
                    onChange={this.onDataStoreChange}
                  />
                </FormField>
              </div>
            </ColumnLayout>
          </FormSection>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/dev_config.jsx